import { FC } from 'react'
import { getCategoriesByIds } from '../store/module'
import useJobCategoryStore from '../store/store.jobCategory'
import ContainerCategoryGroup from './ContainerCategoryGroup'

interface IFFirstCategoriesProps {
  className?: string
}

const FirstCategories: FC<IFFirstCategoriesProps> = ({ className }) => {
  const jobCategoryStore = useJobCategoryStore()
  const { categories, idsByDepth } = jobCategoryStore

  const firstDepthId = idsByDepth?.[1]
  const firstCategories =
    firstDepthId && getCategoriesByIds(firstDepthId, categories)

  return (
    <ContainerCategoryGroup
      categories={firstCategories}
      className={className}
    />
  )
}

export default FirstCategories
